import document from './assets/document.png';
import devices from './assets/devices.png';
import gear from './assets/gear.png';
import social from './assets/social.png';
import lock from './assets/lock.png';
import child from './assets/child.png';
import california from './assets/california.png';
import nevada from './assets/nevada.png';
import lightbulb from './assets/lightbulb.png';

export default {
	personal: {
		title: '¿Qué información personal recopilamos y cómo lo hacemos?',
		image: document,
		alt: 'Document Icon',
	},
	collect: {
		title: '¿Dónde/Cómo recopilamos la Información Personal?',
		image: devices,
		alt: 'Devices Icon',
	},
	use: {
		title: '¿Cómo utilizamos la Información Personal?',
		image: gear,
		alt: 'Gear Icon',
	},
	social: {
		title: '¿Con quién compartimos la información personal?',
		image: social,
		alt: 'Social Icon',
	},
	control: {
		title: '¿Cómo puede controlar el uso que hacemos de la información personal?',
		image: lock,
		alt: 'Lock Icon',
	},
	children: {
		title: 'Privacidad de los niños',
		image: child,
		alt: 'Child Icon',
	},
	section4: {
		title: 'Derechos para nuestros residentes de California',
		image: california,
		alt: 'California Icon',
	},
	nevada: {
		title: 'Derechos para nuestros residentes de Nevada',
		image: nevada,
		alt: 'Nevada Icon',
	},
	learn: {
		title: '¿Cómo puede obtener más información?',
		image: lightbulb,
		alt: 'Lightbulb Icon',
	},
};
